import * as Preact from 'preact'
const { h } = Preact
const img = require('../../../../assets/logos/fifa-logo.png')

interface IProps {
  class?: string
}

const FifaLogo = (props: IProps) => {
  return <img class={props.class} alt="Logo for Fotball-VM 2018" src={img} />
}

export { FifaLogo }
